<template>
  <div @mouseleave.stop="onMouseLeave">
    <transition name="fade">
      <div class="content__toast" v-if="showCopyToastLayer && url !== 'Direct'" :class="{'center': type === 'center'}">
        <span>{{ $t('common.trackingCode.copied') }}</span>
        <i class="icon icon--check-green-size16"></i>
      </div>
    </transition>
    <div class="url-container" :class="{'hover': urlHover, 'center': type === 'center'}" >
      <p class="url ellipsis" :class="{'nolink': url === 'Direct'}"  >
        <button type="button" v-if="url !== 'Direct' " class="outlink icon icon--link-size16"
                @click="$emit('onUrlLink', url)"></button>
        <span class="" @click="copy($event)" @mouseenter="onMouseEnter">{{url}}</span>
        <span class="real-url" >
          {{getUrlByType}}
        </span>
      </p>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import { getConversionUrl } from '@/libs/analytics-helper'

export default {
  props: {
    type: {
      type: String,
      default: '',
      required: false
    },
    url: {
      type: String,
      required: true,
      default: ''
    },
    option: {
      type: String,
      default: 'refer',
      required: false
    }
  },
  watch: {

  },
  data () {
    return {
      urlHover: false,
      showCopyToastLayer: false
    }
  },
  computed: {
    ...mapState([
      'applyData'
    ]),
    getUrlByType () {
      if (this.type === 'center') {
        return this.url
      } else {
        if (this.option === 'refer') {
          return 'http://' + this.url
        } else {
          return getConversionUrl(this.url, this.applyData.hostname)
        }
      }
    }
  },
  methods: {
    onMouseEnter () {
      if (this.url !== 'Direct') {
        this.urlHover = true
      }
    },
    onMouseLeave () {
      this.urlHover = false
      this.showCopyToastLayer = false
      let sel = window.getSelection()
      sel.removeAllRanges()
    },
    copy (event) {
      const clickElem = event.target
      const targetElem = clickElem.parentNode.querySelector('.real-url')
      const content = targetElem.innerText

      const userAgent = navigator.userAgent.toLowerCase()
      let isEdge = false
      if ((userAgent.indexOf('chrome') !== -1) && (userAgent.indexOf('edg') !== -1)) {
        isEdge = true
      }

      if (targetElem) {
        if (isEdge) {
          const el = document.createElement('textarea')
          el.value = content
          el.setAttribute('readonly', '')
          el.style.position = 'absolute'
          el.style.left = '-9999px'
          document.body.appendChild(el)
          const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
          if (selected) {
            document.getSelection().removeAllRanges()
            document.getSelection().addRange(selected)
          }
        } else {
          let range = document.createRange()
          range.setStartBefore(targetElem)
          range.setEndAfter(targetElem)
          let sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(range)
          document.execCommand('copy', false)

          range.setStartBefore(clickElem)
          range.setEndAfter(clickElem)
          sel.removeAllRanges()
          sel.addRange(range)
        }

        this.showCopyToastLayer = true
        setTimeout(() => {
          this.showCopyToastLayer = false
        }, 5000)
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.fade-leave-active,
.fade-enter-active {
  transition: opacity 0.2s ease;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.real-url {
  position: absolute;
  left: -999999px;
}

.content__toast {
  display: inline-block;
  height: 32px;
  border-radius: 6px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
  background-color: rgba(0,0,0,0.85);
  position: absolute;
  top: -30px;
  left: 21px;
  padding-left: 12px;
  padding-right: 45px;
  &.center {
    top: 0px;
    left: 50%;
    transform: translate(-50%, 0%);
    width: max-content;
    z-index: 9999;
  }
  span {
    font-size: 13px;
    font-weight: 600;
    color: #57ab00;
    line-height: 32px;
  }
  i {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }
}

.url {
  float: left;
  font-weight: 500;
  color: #444;
  font-size: 14px;
  //padding-left: 5px;
  line-height: 22px;
  margin-top: -4px;
  width: 100%;

  & > span {
    max-width: 560px;
  }

  &.nolink {
    padding-left: 21px;
  }
}
.outlink {
  float: left;
  margin: 3px 7px 0 3px;
}

.url-container {
  position: relative;
  display: inline-block;
  height: 17px;
  margin-top: 8px;
  padding-top: 5px;
  width: 95%;

  &.center {
    margin-bottom: 6px;
    & > .url {
      color: #fff;
      & > .outlink {
        display: none;
      }
    }
  }

  &.hover {
    max-width: 561px;
    width: max-content;
    width: -moz-max-content;
    border-radius: 4px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    z-index: 999999;
    padding-right: 6px;

    & > .url {
      display: inline;
      padding: 0;
      font-size: 12px;
      margin-top: -5px;
      font-weight: 500;
      max-width: 560px;
      width: initial;

      & > .outlink {
        display: block;

        background-image: url(../../assets/img/icon_link_blue_size16.svg);
      }

    }

    &.center {
      & > .url {
        color: #555555;
      }
    }
  }
}
</style>
